module.exports = __webpack_public_path__ + "static/img/anxun62.1c9b1ea3.png";